new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');
            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                var inputElement = document.getElementById("valorParaCopiar");
                if (inputElement) {
                    var newValueInput = inputElement.value.replace(/^\/\//, '');
                    inputElement.value = newValueInput

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            inputElement.select();

                            document.execCommand("copy");

                            window.getSelection().removeAllRanges();

                            alert("Valor copiado: " + newValueInput);
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.first-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list');
        if (vitrineCarrousel) {
            $('#product_list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    // waitForElementToExist('.home__banner').then(element => {
    //     function ajustarAlturaBanner() {
    //         if (window.outerWidth < 992) {
    //             const header = document.querySelector('#app_header');
    //             const banner = document.querySelector('.home__banner');

    //             if (header && banner) {
    //                 const headerHeight = header.offsetHeight;
    //                 const alturaCalculada = window.innerHeight - headerHeight + 10;
    //                 banner.style.height = `${alturaCalculada}px`;
    //             }
    //         }else if (window.outerWidth >= 992) {
    //             const header = document.querySelector('#app_header');
    //             const banner = document.querySelector('.home__banner');

    //             if (header && banner) {
    //                 banner.style.height = `auto`;
    //             }
    //         }
    //     }

    //     // Ajusta ao carregar a página
    //     ajustarAlturaBanner();

    //     // Também é uma boa ajustar ao redimensionar a tela
    //     window.addEventListener('resize', ajustarAlturaBanner);

    // });

    waitForElementToExist('.categories').then(element => {
        if (window.matchMedia("(max-width: 991px)").matches) {
            const categoriesHome = document.querySelector('.home .categories');
            if (categoriesHome) {
                $('#categories-home-carrousel').slick({
                    arrows: false,
                    infinite: true,
                    autoplay: true,
                    dots: false,
                    mobileFirst: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    speed: 1000,
                    autoplaySpeed: 3000,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: 'unslick'
                        }
                    ]
                });
            }
        }
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            prevArrow: $(".count .count-prev"),
            nextArrow: $(".count .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            prevArrow: $(".count .count-prev2"),
            nextArrow: $(".count .count-next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5, #carrousel-product-list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.rotation-vitrine.second-rotation').then(element => {
        $('#carrousel-product-list3').slick({
            arrows: true,
            prevArrow: $(".second-rotation .count .count-prev3"),
            nextArrow: $(".second-rotation .count .count-next3"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list4').slick({
            arrows: true,
            prevArrow: $(".second-rotation .count .count-prev4"),
            nextArrow: $(".second-rotation .count .count-next4"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }

                    // Atualizar classe no contêiner .count
                    $('.second-rotation .count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 3}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list3',
                        '#carrousel-product-list4',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5, #carrousel-product-list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        const banner = element.querySelector('#faixa-comunicado');

        if (banner) {
            $('#faixa-comunicado').slick({
                arrows: false,
                dots: true,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list3');
        if (vitrineCarrousel) {
            $('#product_list3').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.four-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list4');
        if (vitrineCarrousel) {
            $('#product_list4').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.five-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list5');
        if (vitrineCarrousel) {
            $('#product_list5').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.six-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list6');
        if (vitrineCarrousel) {
            $('#product_list6').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.seven-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list7');
        if (vitrineCarrousel) {
            $('#product_list7').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1275,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list7').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.banner-full').then(element => {
        $('.banner-full-content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
        });
    });

});